import React__default from "react";
import { Box } from "../Box/Box.js";
import { isNumber } from "../../utils/functions/isNumber.js";
const Flex = ({
  align = "stretch",
  children = null,
  className = "",
  direction = "row",
  gap = "s",
  justify = "start",
  style = {},
  wrap = "noWrap"
}) => /* @__PURE__ */ React__default.createElement(
  Box,
  {
    className,
    style: {
      alignItems: getAlignStyle(align),
      display: "flex",
      flexDirection: getDirectionStyle(direction),
      gap: getGapStyle(gap),
      justifyContent: getJustifyStyle(justify),
      flexWrap: getWrapStyle(wrap),
      ...style
    }
  },
  children
);
const getAlignStyle = (align) => {
  switch (align) {
    case "center": {
      return "center";
    }
    case "end": {
      return "flex-end";
    }
    case "stretch": {
      return "stretch";
    }
    case "baseline": {
      return "baseline";
    }
    case "start":
    default: {
      return "flex-start";
    }
  }
};
const getDirectionStyle = (flexDirection) => {
  switch (flexDirection) {
    case "column":
      return "column";
    case "rowReverse":
      return "row-reverse";
    case "columnReverse":
      return "column-reverse";
    case "row":
    default:
      return "row";
  }
};
const getGapStyle = (size) => {
  if (isNumber(size)) {
    return `${size}px`;
  }
  switch (size) {
    case "xl":
      return "64px";
    case "l":
      return "32px";
    case "m":
      return "16px";
    case "s":
      return "8px";
    case "xs":
    default:
      return "4px";
  }
};
const getJustifyStyle = (align) => {
  switch (align) {
    case "center": {
      return "center";
    }
    case "end": {
      return "flex-end";
    }
    case "between": {
      return "space-between";
    }
    case "start":
    default: {
      return "flex-start";
    }
  }
};
const getWrapStyle = (align) => {
  switch (align) {
    case "wrap": {
      return "wrap";
    }
    case "wrapReverse": {
      return "wrap-reverse";
    }
    case "noWrap":
    default: {
      return "nowrap";
    }
  }
};
export {
  Flex
};
//# sourceMappingURL=Flex.js.map
